import { useAppSelector } from 'app/hooks';
import GridDraggableItem from 'components/structure-page/2d/grid-draggable-item';

export default function FenestrationList() {
  const { estimatingStructure } = useAppSelector((state) => state.ui);

  return (
    <div className='flex flex-col gap-4 pt-4'>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-semibold text-gray-500'>Windows</span>
        <GridDraggableItem
          id='window-small'
          label='Small Window'
          type='new-window-small'
          disabled={estimatingStructure}
          color='cyan'
        />
        <GridDraggableItem
          id='window-medium'
          label='Medium Window'
          type='new-window-medium'
          disabled={estimatingStructure}
          color='cyan'
        />
        <GridDraggableItem
          id='window-large'
          label='Large Window'
          type='new-window-large'
          disabled={estimatingStructure}
          color='cyan'
        />
      </div>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-semibold text-gray-500'>Doors</span>
        <GridDraggableItem
          id='door-wood'
          label='Wooden Door'
          type='new-door-wood'
          disabled={estimatingStructure}
          color='orange'
        />
        <GridDraggableItem
          id='door-metal'
          label='Metal Door'
          type='new-door-metal'
          disabled={estimatingStructure}
          color='orange'
        />
        <GridDraggableItem
          id='door-pet'
          label='Pet Door'
          type='new-door-pet'
          disabled={estimatingStructure}
          color='orange'
        />
        <GridDraggableItem
          id='door-glass-single'
          label='Single Glass Door'
          type='new-door-glass-single'
          disabled={estimatingStructure}
          color='cyan'
        />
        <GridDraggableItem
          id='door-glass-double'
          label='Double Glass Door'
          type='new-door-glass-double'
          disabled={estimatingStructure}
          color='cyan'
        />
        <GridDraggableItem
          id='door-garage-single'
          label='Single Garage Door'
          type='new-door-garage-single'
          disabled={estimatingStructure}
          color='orange'
        />
        <GridDraggableItem
          id='door-garage-double'
          label='Double Garage Door'
          type='new-door-garage-double'
          disabled={estimatingStructure}
          color='orange'
        />
      </div>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-semibold text-gray-500'>Skylights</span>
        <GridDraggableItem
          id='skylight-small'
          label='Small Skylight'
          type='new-skylight-small'
          disabled={estimatingStructure}
          color='yellow'
        />
        <GridDraggableItem
          id='skylight-medium'
          label='Medium Skylight'
          type='new-skylight-medium'
          disabled={estimatingStructure}
          color='yellow'
        />
        <GridDraggableItem
          id='skylight-large'
          label='Large Skylight'
          type='new-skylight-large'
          disabled={estimatingStructure}
          color='yellow'
        />
      </div>
    </div>
  );
}
